export default "__VITE_ASSET__D$$92K3u__"